




























































































































































import { computed, defineComponent, toRefs, PropType, ref } from '@vue/composition-api';
import { IDENTITY_TYPE_MAP } from '@tt4b/ttam-enums';
import defaultAvatar from '@tt4b/ttam-assets/src/images/creative/default-avatar.png';
import { i18n } from '@tt4b/ttam-i18n';
import { getScene } from '@tt4b/ttam-utils';
import { useCreativeActionTypeIs, useAllowlist } from '@tt4b/ttam-hooks';
import { trackEvent } from './../../../../utils/index';

const name = 'ttam-library-header';

export default defineComponent({
  name,
  props: {
    isHideLink: { type: Boolean, default: false },
    componentToRender: {
      type: Object,
      required: false,
    },
    title: { type: String, default: '' },
    keyword: { type: String, default: '' },
    sortType: { type: [Number, Boolean], default: undefined },
    sortOptions: { type: Array as PropType<{ value: number; label: string }[]>, default: () => [] },
    filterTypes: { type: Array as PropType<number[]>, default: undefined },
    filterOptions: { type: Array, default: () => [] },
    identityInfo: {
      type: Object as PropType<{ avatar: string; name: string; identityType: number }>,
      default: () => ({}),
    },
    isShowIdentity: { type: Boolean, default: false },
    isHideLinkAndSort: { type: Boolean, default: false },
    isShowUpload: { type: Boolean, default: false },
    isShowCommonFilter: { type: Boolean, default: true },
    isShowTtNativeFilter: { type: Boolean, default: false }, // isTTANative
    isAcoWithTtaNativeAds: { type: Boolean, default: false },
    createMode: { type: String, default: () => '' },
    isAco: { type: Boolean, default: false },
  },

  setup(props, { emit }) {
    const { identityInfo, isAco, createMode } = toRefs(props);
    const { isNativeCreativeSearchWhite } = useAllowlist();
    const curSortType = computed({
      get: () => props.sortType,
      set: val => {
        trackEvent('creative_spark_ads_post_sort', { type: val });
        emit('sort-type-change', val);
      },
    });
    const curKeyword = computed({
      get: () => props.keyword,
      set: val => emit('keyword-change', val),
    });
    const curFilterType = computed({
      get: () => props.filterTypes,
      set: val => {
        val = val || [];
        trackEvent('creative_spark_ads_post_filter', { type: val.join(',') });

        emit('filter-type-change', val);
      },
    });

    const identityName = computed(() => identityInfo.value.name);

    const identityAvatarIcon = computed(() => identityInfo.value.avatar);

    function getFilterSelectedLabel() {
      return `${i18n.t('module_creative_post_filter')} (${props.filterTypes.length})`;
    }

    function onKeywordChange(eventTarget) {
      curKeyword.value = eventTarget?.target?.value ?? '';
      if (identityInfo.value.identityType === IDENTITY_TYPE_MAP.AUTH_CODE_USER) {
        trackEvent('spark_ads_search_click');
      }
    }

    function search() {
      emit('search');
    }

    function goToLibrary() {
      const { isEdit, isCopy } = useCreativeActionTypeIs({
        createMode,
        adgroupData: ref({}) as any,
      });
      trackEvent('module_library_link', {
        scene: getScene({
          isEdit: isEdit.value,
          isCopy: isCopy.value,
        }),
      });
      emit('open-library');
    }

    function onAddNativePost() {
      trackEvent('library_authorize_post', {
        is_aco: Boolean(isAco.value),
      });
      emit('add-post');
    }
    const handleVisibleChange = status => {
      if (status) {
        emit('tea-report', 'smb_create_ad_video_lib_sort');
      }
    };
    const filesSelected = files => {
      emit('files-selected', files);
    };
    return {
      curSortType,
      search,
      curKeyword,
      goToLibrary,
      identityName,
      curFilterType,
      filesSelected,
      onAddNativePost,
      onKeywordChange,
      identityAvatarIcon,
      handleVisibleChange,
      getFilterSelectedLabel,
      isNativeCreativeSearchWhite,
    };
  },
});
